import { api } from '@/api'
import { ISimpleResponse } from '@/modules/login/types'

export interface UpdateTrafficDetectorReq {
  imageId: string
  id: number
  name: string
  address: string
  coordinates: string
  ip: string
  port: number
  sameDirectionSensors: number[]
  oppositeDirectionSensors: number[]
  favoriteCategoryIds?: number[]
}

const updateTrafficDetectorService = api.injectEndpoints({
  endpoints: (build) => ({
    updateTrafficDetector: build.mutation<
      ISimpleResponse,
      UpdateTrafficDetectorReq
    >({
      query: (body) => ({
        url: '/devices/updateTrafficDetector',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useUpdateTrafficDetectorMutation } = updateTrafficDetectorService
